import React, { useState, useContext } from "react";
import "./modal.scss";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { FaPlusCircle } from "react-icons/fa";
import pic from "../../../assets/images/icons8-user-96.png";
import useConfig from "react-rating-stars-component/dist/hooks/useConfig";
import UserContext from "context/UserContext";
import { AiFillEdit } from "react-icons/ai";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import useInput from "../../../hooks/use-input";
import { Modal } from "react-bootstrap";
import { connection } from "utils/apiConnection.ts";
function UserEditModal({
  profileValue,
  EditUser,
  Update,
  updater,
  setUpdater,
  setIsLoading,
}) {
  const auth = useContext(WithAuthentication);

  const [show, setShow] = useState(false);
  const [img, setimg] = useState("");
  // console.log("j", profileValue);
  // console.log("user", user);
  const editHandler = (profileValue) => {
    let myFormData = new FormData();
    //let id = 117;
    // let id = 1;
    myFormData.append("userId", `${auth.userInfo.id}`);
    myFormData.append(
      "updateValue",
      `fullname,${profileValue.fullname}@@mobile,${profileValue.mobile}@@codemeli,${profileValue.codemeli}@@tell,${profileValue.tell}@@address,${profileValue.address}`
    );
    myFormData.append("file", profileValue.path);
    // console.log("profileValue.address", profileValue.address);
    // console.log(mobile);
    // console.log(codemeli);
    // console.log(telephone);
    console.log("prof", profileValue);
    for (var [key, value] of myFormData.entries()) {
      console.log("mf", key, value);
    }
    if (!mobile.isValid) {
      setIsLoading(false);
      toast.error("فیلدها را به صورت صحیح پر کنید");
    } else {
      connection("api/updateuser", myFormData).then((res) => {
        if (+res.status === 1) {
          toast.success("اطلاعات با موفقیت ثبت شد!");
          setShow(false);
          setIsLoading(false);
          setUpdater(!updater);
          auth.changeName(profileValue.fullname);
        }
      });
    }
    for (var [key, value] of myFormData.entries()) {
      console.log("formData", key, value);
    }
  };

  // const codemeliReg = /^[\d\u0660-\u0669\u06F0-\u06F9]{10}$/;
  // const numReg = /^\d+$/;
  // const mobileReg = /^(\+98|0)9[\d\u0660-\u0669\u06F0-\u06F9]{9}$/;
  // console.log(profileValue);
  // mobileReg.test();

  // const codemeli = useInput(
  //   (value) => /^[\d\u0660-\u0669\u06F0-\u06F9]{10}$/.test(value),
  //   profileValue.codemeli
  // );
  const mobile = useInput(
    (value) =>
      /^(\+98|\+\u0669\u0668|\+\u06F9\u06F8|0|\u0660|\u06F0)(9|\u0669|\u06F9)[\d\u0660-\u0669\u06F0-\u06F9]{9}$/.test(
        value
      ),
    profileValue.mobile
  );

  // const telephone = useInput(
  //   (value) =>
  //     /^(\+98|\+\u0669\u0668|\+\u06F9\u06F8|0|\u0660|\u06F0)[\d\u0660-\u0669\u06F0-\u06F9]{10}$/.test(
  //       value
  //     ),
  //   profileValue.tell
  // );
  return (
    <>
      <p onClick={() => setShow(!show)}>
        <bdi style={{ cursor: "pointer" }}>
          {" "}
          <AiFillEdit />
          ویرایش اطلاعات
        </bdi>
      </p>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ویرایش کاربر</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="edit-user-container">
            <form id="edit-user-form-data">
              <div className="edit-user-item d-flex justify-content-between">
                <label htmlFor="profile-pic">
                  <div className="profile-pic position-relative">
                    <input
                      className="d-none"
                      type="file"
                      accept="image/*"
                      id="profile-pic"
                      onChange={(e) => {
                        EditUser({
                          ...profileValue,
                          ["path"]: e.target.files[0],
                        });
                        setimg(URL.createObjectURL(e.target.files[0]));
                      }}
                    />
                    {profileValue.path == null || profileValue.path == "" ? (
                      <img
                        src={pic}
                        alt=""
                        style={{
                          width: "80px",
                          borderRadius: "50%",
                          height: "80px",
                          overflow: "hidden",
                        }}
                      />
                    ) : (
                      <img
                        src={
                          img === ""
                            ? `${
                                "http://sabadi.tatdemo.ir/" + profileValue.path
                              }`
                            : `${img}`
                        }
                        alt=""
                        style={{
                          width: "80px",
                          borderRadius: "50%",
                          height: "80px",
                          overflow: "hidden",
                        }}
                      />
                    )}
                    <label
                      htmlFor="profile-pic"
                      className="position-absolute text-light"
                      style={{
                        right: "29px",
                        top: "25px",
                        opacity: "0.6",
                        fontSize: "22px",
                        cursor: "pointer",
                      }}
                    >
                      <FaPlusCircle />
                    </label>
                  </div>
                </label>

                {/* <input
                      type="file"
                      className="form-control"
                      value={profileValue.profilePicture}
                      // onChange={(e) => {
                      //   setProfileSrc(e.target.value);
                      // }}
                      // value={ProfileSrc}
                      id="profile-pic"
                      name="profilePicture"
                      hidden
                    /> */}
              </div>

              <div className="edit-user-item mt-3 d-flex justify-content-between mb-2">
                <label className="title col-3" htmlFor="fullname-edit-user">
                  نام و نام خانوادگی
                </label>
                <div className="col-7">
                  <input
                    type="text"
                    className="form-control"
                    value={profileValue.fullname}
                    onChange={(e) =>
                      EditUser({
                        ...profileValue,
                        [e.target.name]: e.target.value,
                      })
                    }
                    name="fullname"
                    id="fullname-edit-user"
                  />
                </div>
              </div>

              <div className="edit-user-item d-flex justify-content-between mb-2 ">
                <label
                  className="title col-3"
                  htmlFor="national-code-edit-user"
                >
                  کد ملی
                </label>
                <div className="d-flex flex-column col-7">
                  <input
                    type="text"
                    className="form-control text-start"
                    value={profileValue.codemeli}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      EditUser({
                        ...profileValue,
                        [e.target.name]: e.target.value,
                      });
                      //codemeli.changeHandler(e);
                    }}
                    // min="10"
                    name="codemeli"
                    id="codemeli-code-edit-user"
                    //onBlur={codemeli.blurHandler}
                  />
                  {/* {codemeli.hasError ? (
                    <div style={{ fontSize: "12px", color: "#cf1414" }}>
                      کدملی 10 رقم میباشد
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>

              <div className="edit-user-item d-flex justify-content-between mb-2">
                <label htmlFor="address-edit-user" className="title col-3">
                  آدرس{" "}
                </label>
                <div className="col-7">
                  <input
                    type="text"
                    className="form-control"
                    value={profileValue.address}
                    onChange={(e) =>
                      EditUser({
                        ...profileValue,
                        [e.target.name]: e.target.value,
                      })
                    }
                    name="address"
                    id="address-edit-user"
                  />
                </div>
              </div>
              <div className="edit-user-item d-flex justify-content-between mb-2">
                <label
                  className="title col-3"
                  htmlFor="national-code-edit-user"
                >
                  شماره تماس
                </label>
                <div className="col-7">
                  <input
                    type="text"
                    className="form-control text-start"
                    value={profileValue.telephone}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      EditUser({
                        ...profileValue,
                        [e.target.name]: e.target.value,
                      });
                      //telephone.changeHandler(e);
                    }}
                    name="tell"
                    id="national-code-edit-user"
                    //onBlur={telephone.blurHandler}
                  />
                  {/* {telephone.hasError ? (
                    <div style={{ fontSize: "12px", color: "#cf1414" }}>
                      شماره تماس را صحیح وارد کنید
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>
              <div className="edit-user-item d-flex justify-content-between mb-2">
                <label
                  className="title col-3"
                  htmlFor="national-code-edit-user"
                >
                  موبایل
                </label>
                <div className="col-7">
                  <input
                    type="text"
                    readOnly
                    className="form-control text-start"
                    value={mobile.value}
                    onChange={(e) => {
                      EditUser({
                        ...profileValue,
                        [e.target.name]: e.target.value,
                      });
                      mobile.changeHandler(e);
                    }}
                    onBlur={mobile.blurHandler}
                    name="mobile"
                    id="national-code-edit-user"
                  />
                  {mobile.hasError ? (
                    <div style={{ fontSize: "12px", color: "#cf1414" }}>
                      شماره موبایل را صحیح وارد کنید
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShow(false)}
          >
            بستن
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              editHandler(profileValue);
              setimg("");
            }}
          >
            ذخیره
          </button>
        </Modal.Footer>
      </Modal>
      <div>
        <Toaster />
      </div>
    </>
  );
}

export default UserEditModal;
